<template>
  <header
    class="
      navbar
      drop-shadow
      fixed
      inset-x-0
      top-0
      z-30
      h-auto
      py-2
      bg-white
      md:px-11
    "
  >
    <div class="flex items-center justify-between">
      <a
        href="#"
        class="flex flex-col items-center px-3 ml-2 md:hidden cursor-pointer"
        @click.prevent="toggleProductsMenu"
      >
        <img
          class="w-6 h-5"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAeCAMAAABzP0xhAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPFBMVEVHcEwiHh4iHh8iHh4iHh8iHh4iHh8iHh4iHh8iHh4iHh8iHh8iHh4iHh8iHh8iHh8iHh4iHh4iHh4iHh/aBcxbAAAAE3RSTlMA9GLelhWiTz7HcQatMNTqvCWC4WxJFQAAAe9JREFUOBFtU4mW5CAIRCXBA4/o///rFtozr/N2yo5KUyKXRB9w7z20ltIYKbUWenB3+VF+1qhJ7zmzF8D7OW8dGt+kx7/lLRX/vP71Zrlg2G/vTCivo1GIcgMSNl+Q7wvzRXMdvFglnxN1KsdMV18OLLcGlXKiwlpyZJ2VoAos5DfHjL2cFe44SbxWD4HbuQxU9dn7nQnJjHytxURPVCPAot33HzQe0wmaQ7DZOQg/Y610HHwiJxj9Cy6xHEM2X3GgbC243p2NYNKQC6pD4tvXQjE005wCp4Ra90il+htugykyNQ0O5g1cutNeLDMj6ZR9Xw7+KuRDyplZmxvJNWXOfnRP5ZIwYeleqzH71mcExGe0i+1mb54Zkd8gqVNFKlOWnPMEBTQsWTwITYdTxCVF4M5ySWKt9cG3pyjwza0A9YXgiQYkFGeo3gDjUx1WELcSUTykalGtezIbAcBmwlegHlKVm+D2Wj8NdupAEcabJyQRluoMcB9pgzMW1QEESzFRm0YSpHNmucq18QBnhxzliVSa49P6KvlmbWWF+bw7+N38wJXMFxWpEdzdU9vVr2nAWKyCW70byhmFQGif4LCayJonkmmPQezo6QdIv9gxPqaz9/MgRR2Ns5/mNwe0Ym8IqSL61PBX/7UpeCbo339g9SI2RfiFngAAAABJRU5ErkJggg=="
          alt="Icon Mobil Daihatsu"
          height="20"
          width="24"
        />
        <div class="text-[9px] pt-1 uppercase">Produk</div>
      </a>
      <a href="https://daihatsu.co.id" class="md:py-1">
        <img
          src="https://unpkg.com/daihatsu-ui@1.1.0/dist/img/daihatsu-logo.55d429db.svg"
          alt="Logo Daihatsu"
          class="h-[30px] md:h-[40px]"
          height="30"
          width="120"
        />
      </a>
      <a
        href="#"
        class="py-1 px-3 mr-2 w-[50px] md:hidden cursor-pointer"
        @click.prevent="toggleMenu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            v-if="!menuOpened"
            fill-rule="evenodd"
            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clip-rule="evenodd"
          />
          <path
            v-else
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </a>
      <expand-transition>
        <nav
          class="
            absolute
            md:static
            w-full
            md:w-auto md:flex
            top-[53px]
            bg-white
            px-4
            divide-y divide-gray-200
            md:divide-y-0
            drop-shadow
            md:drop-shadow-none
          "
          :class="!menuOpened && 'hidden'"
        >
          <div
            v-for="menu in menus"
            :key="menu.name"
            class="
              px-4
              py-3
              md:p-3
              text-sm
              md:text-base
              whitespace-nowrap
              hover:text-monza
              md:uppercase
            "
            :class="menu.class"
          >
            <a v-if="!menu.submenus && !menu.isProduct" :href="menu.link">{{
              menu.name
            }}</a>
            <div
              v-if="menu.submenus"
              class="dropdown-menu items-center cursor-pointer relative pr-6"
              @click="toggleDropdownActive"
            >
              <span>{{ menu.name }}</span>
              <span class="absolute right-0 md:top-[2px]"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-5 h-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  /></svg
              ></span>
              <div
                class="
                  menu-container
                  divide-y divide-gray-200
                  min-w-max
                  md:absolute
                  bg-white
                  mt-3
                  md:mt-0
                  right-0
                  hidden
                  top-10
                  md:drop-shadow-xl md:border
                "
              >
                <a
                  v-for="submenu in menu.submenus"
                  class="
                    menu-item
                    block
                    px-4
                    py-3
                    hover:text-monza
                    text-sm
                    whitespace-nowrap
                  "
                  :href="submenu.link"
                  :key="submenu.name"
                  >{{ submenu.name }}</a
                >
              </div>
            </div>
            <div
              v-if="menu.isProduct"
              class="items-center cursor-pointer relative pr-6"
              @click="toggleProductsMenu"
            >
              <span>{{ menu.name }}</span>
              <span class="absolute right-0 md:top-[2px]"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-5 h-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  /></svg
              ></span>
            </div>
          </div>
        </nav>
      </expand-transition>
    </div>
    <expand-transition>
      <div
        :class="!productsMenuOpened && 'hidden'"
        class="
          flex flex-col
          md:flex-row
          flex-nowrap
          md:flex-wrap md:justify-center
          h-screen
          md:h-auto
          pb-28
          md:pb-0
          divide-y divide-gray-200
          md:divide-y-0 md:rounded md:absolute md:w-[730px]
          pt-0
          bg-white
          border
          overflow-y-auto
          right-6
        "
      >
        <a
          v-for="product in products"
          :key="product.id"
          class="
            flex
            items-center
            px-4
            py-3
            md:flex-col md:py-1 md:px-0 md:hover:bg-monza md:hover:text-white
          "
          :href="`https://daihatsu.co.id/product/${product.slug}/`"
        >
          <img
            class="w-28 md:w-36"
            :src="cdnImg(product.thumbnail, 200)"
            width="120"
            height="66"
            :alt="product.alt_image"
            loading="lazy"
          />
          <div class="md:text-center">
            <div class="font-semibold uppercase">
              {{ product.name }}
            </div>
            <div class="text-xs md:uppercase">
              Mulai {{ toRupiah(product.price) }}
            </div>
          </div>
        </a>
      </div>
    </expand-transition>
  </header>
</template>

<script>
import ExpandTransition from '@/components/lib/ExpandTransition.vue'
import 'unfetch/polyfill'
import { cdnImg } from '@/utils.js'

const afterSalesSubmenus = [
  { name: 'After Sales Service', link: 'https://daihatsu.co.id' },
  {
    name: 'Booking Service',
    link: 'https://daihatsu.co.id/ownership/booking-service/',
  },
  {
    name: 'Daihatsu Mobile Apps',
    link: 'https://daihatsu.co.id/ownership/mobile-apps/',
  },
  {
    name: 'Daihatsu We Care',
    link: 'https://daihatsu.co.id/ownership/daihatsu-cares/',
  },
  { name: 'Recall Program', link: 'https://recall.daihatsu.co.id' },
  { name: 'Daihatsu Sparepart', link: 'https://daihatsu-sparepart.com' },
  { name: 'Daihatsu Genuine Oil', link: '#' },
]

const menus = [
  { name: 'Beranda', link: 'https://daihatsu.co.id' },
  { name: 'Product', link: '#', class: 'hidden md:block', isProduct: true },
  { name: 'Price List', link: 'https://daihatsu.co.id/price-list/' },
  { name: 'After Sales', link: '#', submenus: afterSalesSubmenus },
  { name: 'Tips & Event', link: 'https://daihatsu.co.id/tips-and-event/' },
]

export default {
  components: { ExpandTransition },
  name: 'Navbar',
  data() {
    return {
      menuOpened: false,
      productsMenuOpened: false,
      products: [],
      menus,
      activedMenu: 0,
    }
  },
  created() {
    this.getProducts()
  },
  methods: {
    toggleDropdownActive({ target }) {
      const menu = target.closest('.dropdown-menu')
      const state = menu.classList.contains('active')

      this.productsMenuOpened = false
      this.removeDropdownActiveClass()

      state ? menu.classList.remove('active') : menu.classList.add('active')
    },
    removeDropdownActiveClass() {
      document
        .querySelector('daihatsu-navbar')
        .shadowRoot.querySelectorAll('.dropdown-menu')
        .forEach((el) => el.classList.remove('active'))
    },
    cdnImg(...x) {
      return cdnImg(...x)
    },
    toRupiah(val) {
      const split = val.toString().split('').reverse().join('')
      let condition = split.match(/\d{1,3}/g)
      condition = condition.join('.').split('').reverse().join('')
      return 'Rp ' + condition
    },
    toggleMenu() {
      this.productsMenuOpened = false
      this.removeDropdownActiveClass()
      this.menuOpened = !this.menuOpened
    },
    selectMenu(i) {
      if (i === 1) {
        this.toggleProductsMenu()
        return
      }
      this.activedMenu = i
    },
    toggleProductsMenu() {
      this.menuOpened = false
      this.removeDropdownActiveClass()
      this.productsMenuOpened = !this.productsMenuOpened
    },
    async getProducts() {
      try {
        const response = await fetch(
          'https://cms.daihatsu.co.id/api/list_product'
        )
        const {
          data: { product },
        } = await response.json()
        this.products = product
      } catch ({ response }) {
        console.log(response.data)
      }
    },
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;500&display=swap');
</style>

<style lang="scss" scoped>
@import url('../assets/scss/tailwind.scss');

.navbar {
  font-family: 'Ubuntu';
}

.dropdown-menu {
  &.active {
    .menu-container {
      display: block;

      .menu-item {
        color: rgb(31, 41, 55);

        &:hover {
          color: rgba(219, 0, 29);
        }
      }
    }
  }
}
</style>
